export const storePassword = (password: string) => {
  localStorage.setItem('kumon_password', password);
};

export const getPassword = (): string | null => {
  return localStorage.getItem('kumon_password');
};
